import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import InputField from 'forms/shared/fields/input'
import TextAreaField from 'forms/shared/fields/text-area'
import SelectDropdownField from 'forms/shared/fields/select-dropdown'
import DatePickerDropdownField from 'forms/shared/fields/date-picker-dropdown'
import ContactField from 'forms/shared/fields/contact'
import CheckBoxField from 'forms/shared/fields/checkbox'

const checkboxInputClass = 'shadow-sm rounded-none border text-gray-700 leading-tight focus:border-0 focus:outline-none focus:shadow-outline'

const Fields = ({ spaceOptions, form }) => (
  <div className="m-3">
    <Field
      type="dropdown"
      name="space"
      options={spaceOptions}
      placeholder={'Select a Space..'}
      groupClassName="my-4"
      inputClassName="pl-2 pt-2 regular text-xs"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={SelectDropdownField}
    />
    <Field
      type="dropdown"
      name="schedule"
      groupClassName="w-full"
      inputClassName="regular text-sm w-full"
      inputGroupClassName=""
      showIcon
      showText={false}
      formName={form}
      showUncertain={true}
      placeholderClassName="text-sm w-full text-primary-lightgray"
      placeholder="When will you be booking the space?"
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={DatePickerDropdownField}
    />
    <Field
      type="text"
      name="fullName"
      groupClassName="my-4"
      placeHolder="Full Name"
      disabled
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="text"
      name="email"
      groupClassName="my-4"
      placeHolder="Email"
      disabled
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="tel"
      name="phone"
      groupClassName="my-4"
      placeHolder="Contact Number"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={ContactField}
    />
    <Field
      type="text"
      name="message"
      rows={5}
      groupClassName="my-4"
      placeholder="Your message goes directly to the Space Operators - make sure to include as many details as possible!"
      inputClassName="block border text-xs border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={TextAreaField}
    />
    <Field
      type={'checkbox'}
      name={'similarSpaces'}
      label={'Send my message to similar spaces'}
      groupClassName="my-4 flex items-center justify-center"
      labelClassName={'block text-gray-700 text-sm'}
      inputClassName={checkboxInputClass}
      inputErrorClassName={'border-action-danger'}
      errorClassName="text-action-danger text-xs"
      component={CheckBoxField}
    />
  </div>
)

Fields.propTypes = {
  spaceOptions: PropTypes.array,
  form: PropTypes.string
}

export default Fields
